import { MODULE_I18_PREFIX } from '../config/i18.busy';

export const UNMATCH_TASKS_MAIN_TABS_I18_PREFIX =
  `${MODULE_I18_PREFIX}.unmatchTasks.mainTabs` as const;

export const UNMATCH_TASKS_MAIN_TABS = {
  PENDING: 'Pending'
} as const;
